import { Box, Toolbar, Typography } from '@mui/material'
import React from 'react'
import Registerform from '../Component/Registerform'
import Footer from "../Component/Footer";
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom'
import Header from "../Component/header";
import DesktopFooter from "../Component/Desktopfooter";

const Register = () => {
     const { t } = useLanguage();
  return (
    <>
    <div className='text-Wrapper'>
    <Header/> 
        <Box>
            <Toolbar>
            <Registerform/>
            </Toolbar>
        </Box>
        <DesktopFooter/>
        <Footer />
    </div>
    
    
    </>
  )
}

export default Register
